import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewGraficoDetalleInsumos = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'grafico_detalle_insumos',
        name: 'Gráfico Detalle de Insumos',
        component: ViewGraficoDetalleInsumos,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router